module.exports = __webpack_public_path__ + "static/heritage-9e819269630de58484505520b40593b9.jpg";